// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tip-container[data-v-72c554ac]{background-color:#f6f6f6;border-radius:4px;padding:12px 20px;display:flex;align-items:center}.tip-container--error[data-v-72c554ac]{color:#da3636;font-weight:500}", ""]);
// Exports
module.exports = exports;
